import React, { useEffect } from "react";

const Logout = () => {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      // Clear all localStorage items
      localStorage.clear();

      // Reload the page to redirect to the login page
      window.location.reload();
    }
  }, [token]); // Dependency on token to avoid infinite loop

  return null; // No UI needed for logout
};

export default Logout;
